import { CalendarDays, Download, Search } from 'lucide-react'
import { useMemo, useState } from 'react'
import { Button, EmptyState, Modal, StatusTag } from '../../components/shared'
import { exportRecordsCsv } from '../../utils/export'
import { RecordDetail } from './Dashboard'

export default function RecordsPage({ drivers, vehicles, records, onConfirm }) {
  const [query, setQuery] = useState('')
  const [month, setMonth] = useState('2026-07')
  const [phase, setPhase] = useState('all')
  const [status, setStatus] = useState('all')
  const [selected, setSelected] = useState(null)
  const driverMap = Object.fromEntries(drivers.map((item) => [item.id, item]))
  const vehicleMap = Object.fromEntries(vehicles.map((item) => [item.id, item]))
  const filtered = useMemo(() => records.filter((record) => {
    const driver = driverMap[record.driverId]
    const vehicle = vehicleMap[record.vehicleId]
    return record.date.startsWith(month) && (phase === 'all' || record.phase === phase) && (status === 'all' || record.status === status)
      && (!query || `${driver?.name || ''} ${vehicle?.number || ''}`.toLowerCase().includes(query.toLowerCase()))
  }).sort((a, b) => b.createdAt.localeCompare(a.createdAt)), [records, month, phase, status, query])

  return (
    <>
      <div className="page-heading"><div><h2>チェック記録</h2><p>測定値、確認方法、指示事項と監査履歴を検索できます。</p></div><Button icon={Download} variant="secondary" onClick={() => exportRecordsCsv(filtered, drivers, vehicles, `アルコールチェック記録_${month}.csv`)}>CSV出力</Button></div>
      <div className="filter-bar records-filter">
        <label><CalendarDays /><input type="month" value={month} onChange={(event) => setMonth(event.target.value)} /></label>
        <select value={phase} onChange={(event) => setPhase(event.target.value)}><option value="all">業務前・業務後</option><option>業務前</option><option>業務後</option></select>
        <select value={status} onChange={(event) => setStatus(event.target.value)}><option value="all">すべての状態</option><option value="completed">完了</option><option value="review">要確認</option></select>
        <label className="search-field"><Search /><input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="ドライバー・車両番号" /></label>
      </div>
      <div className="table-wrap">
        <table className="data-table records-table"><thead><tr><th>日時</th><th>区分</th><th>ドライバー</th><th>車両</th><th>測定値</th><th>確認方法</th><th>確認者</th><th>状態</th></tr></thead>
          <tbody>{filtered.slice(0, 50).map((record) => {
            const row = { record, driver: driverMap[record.driverId], vehicle: vehicleMap[record.vehicleId] }
            return <tr key={record.id} onClick={() => setSelected(row)}><td>{record.date}<small>{record.time}</small></td><td>{record.phase}</td><td><strong>{row.driver?.name}</strong></td><td>{row.vehicle?.number}</td><td className="measurement-cell">{Number(record.value).toFixed(2)} mg/L</td><td>{record.confirmationMethod}<small>{record.method}</small></td><td>{record.confirmer}</td><td><StatusTag status={record.status} /></td></tr>
          })}</tbody>
        </table>
        {!filtered.length ? <EmptyState title="この期間の記録はありません" detail="対象月または検索条件を変更してください。" /> : null}
        <div className="table-footer"><span>{filtered.length}件中 {Math.min(filtered.length, 50)}件を表示</span></div>
      </div>
      <Modal open={Boolean(selected)} title="チェック記録の詳細" onClose={() => setSelected(null)} wide>{selected ? <RecordDetail row={selected} onConfirm={async (record, details) => { await onConfirm(record, details); setSelected(null) }} /> : null}</Modal>
    </>
  )
}
